import { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import CollectionCard from "@/components/feature/CollectionCard";
import { collections } from "@/mocks/collections";
import { siteConfig } from "@/mocks/site";

export default function CollectionsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCat = searchParams.get("cat") ?? "all";
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    return collections.filter((c) => {
      const matchCat = activeCat === "all" || c.categoryKey === activeCat;
      const q = query.trim().toLowerCase();
      const matchQ =
        !q ||
        c.title.toLowerCase().includes(q) ||
        c.series.toLowerCase().includes(q) ||
        c.author.toLowerCase().includes(q);
      return matchCat && matchQ;
    });
  }, [activeCat, query]);

  return (
    <Layout>
      <section className="bg-background-950 py-12 md:py-16">
        <div className="container-site">
          <nav className="text-xs text-background-300" aria-label="面包屑">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <span className="mx-2">/</span>
            <span className="text-background-100">合集</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            资源合集目录
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-background-200 md:text-base">
            按系列或作者整理的合集整理贴，随目录持续补全。选择分类或输入关键词，快速定位你想要的合集。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="container-site py-10 md:py-14">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={() => setSearchParams({})}
                className={`whitespace-nowrap rounded-full px-1 py-1 text-sm font-medium transition-colors ${
                  activeCat === "all"
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
                style={{ minWidth: "3rem" }}
              >
                全部
              </button>
              {siteConfig.categories.map((c) => (
                <button
                  key={c.key}
                  type="button"
                  onClick={() => setSearchParams({ cat: c.key })}
                  className={`whitespace-nowrap rounded-full px-3 py-1 text-sm font-medium transition-colors ${
                    activeCat === c.key
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {c.name}
                </button>
              ))}
            </div>

            <div className="relative w-full md:w-72">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索系列 / 作者 / 标题"
                className="w-full rounded-md border border-background-300 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
              />
            </div>
          </div>

          <p className="mt-6 text-sm text-foreground-500">
            共 <span className="font-medium text-primary-700">{filtered.length}</span> 个合集整理贴
          </p>

          {filtered.length > 0 ? (
            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {filtered.map((item) => (
                <CollectionCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <div className="mt-10 flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-100/60 py-16 text-center">
              <i className="ri-file-search-line text-4xl text-foreground-400"></i>
              <p className="mt-4 text-sm text-foreground-600">
                没有找到匹配的合集，换个关键词或分类试试。
              </p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}